<template>
  <v-menu
    offset-overflow
    v-bind:position-x="positionX"
    v-bind:position-y="positionY"
    v-bind:value="value"
    v-on:input="onInput">
    <v-list class="menu-status">
      <v-list-item
        v-on:click="emitChangeStatus('new')">
        <v-list-item-title class="menu-status__item">Новая</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-on:click="emitChangeStatus('work')">
        <v-list-item-title class="menu-status__item">В работе</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-on:click="emitChangeStatus('completed')">
        <v-list-item-title class="menu-status__item">Решена</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-on:click="emitChangeStatus('canceled')">
        <v-list-item-title class="menu-status__item">Отказ</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

/**
 * @description Название события изменения статуса.
 * @type {string}
 */
const NAME_EVENT_CHANGE_STATUS = 'change-status';

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

export default {
  name: 'ContextMenuTaskStatus',
  methods: {
    emitChangeStatus(status) {
      this.$emit(NAME_EVENT_CHANGE_STATUS, status);
    },
    onInput(isShown) {
      this.$emit(NAME_EVENT_INPUT, isShown);
    },
  },
  props: {
    positionX: { default: null, type: Number },
    positionY: { default: null, type: Number },
    value: { required: true, type: Boolean },
  },
};
</script>

<style scoped>

</style>
